import {Fragment} from "react";
import Dialog from "./Dialog";
import FormattedButton from "../../FormattedButton";
import {useBoolState} from "@/hooks";
import {useGatewayLimitQuery, useGetCallbackDataQuery, useGetRandomSipUserQuery} from "../queries.generated";
import {MessageDescriptor} from "react-intl";
import {domainAllocationToQuotaInfo} from "@/components/EndpointCreateDialog";

type Props = {
    domainId: number;
    onSuccess: () => void;
    title: MessageDescriptor;
    successItemPath: string;
};

export default (props: Props) => {
    const {domainId, onSuccess, title, successItemPath} = props;
    const [isOpen, setShowOn, setShowOff] = useBoolState();

    const {data} = useGetCallbackDataQuery({
        variables: {
            domainId: props.domainId,
        },
        fetchPolicy: "no-cache",
    });

    const callbackData = data
        ? data
        : {
              extensions: {items: [] as any[]},
              faxes: {items: [] as any[]},
              groups: {items: [] as any[]},
              ivrs: {items: [] as any[]},
          };

    const gatewayLimitQuery = useGatewayLimitQuery({
        variables: {
            domainId: props.domainId,
        },
        fetchPolicy: "no-cache",
    });

    const sipUserQuery = useGetRandomSipUserQuery({
        fetchPolicy: "no-cache",
    });

    if (gatewayLimitQuery.loading || sipUserQuery.loading) return null;

    return (
        <Fragment>
            <FormattedButton onClick={setShowOn} message={title} />
            <Dialog
                title={title}
                domainId={domainId}
                successItemPath={successItemPath}
                onSuccess={() => {
                    onSuccess();
                    gatewayLimitQuery.refetch();
                }}
                isOpen={isOpen}
                close={setShowOff}
                callbackData={callbackData}
                quotaInfo={domainAllocationToQuotaInfo(gatewayLimitQuery.data?.domainAllocation.services.gateway)}
                sipUser={sipUserQuery.data?.sipUser.username}
                sipPassword={sipUserQuery.data?.sipUser.password}
            />
        </Fragment>
    );
};
